import { Gold } from '@wg/wows-react-uikit';

import { thousands } from '~/helpers/formatting';
import { t } from '~/helpers/localization';

import styles from './ErrorDublon.scss';

type IErrorDublon = {
  caption?: string;
  amount: number;
  deficit: number;
};

const ErrorDublon = (props: IErrorDublon) => (
  <div className={styles.error}>
    {!!props.caption && (
      <div>
        <span className={styles.caption}>{props.caption}</span>
        <Gold amount={props.amount} />
      </div>
    )}
    <div className={styles.message}>
      {t('Не хватает: %(deficit)s', {
        deficit: thousands(props.deficit),
      })}
    </div>
  </div>
);

export default ErrorDublon;
